import React from "react";
import { useSelector } from "react-redux";
import SelectionListField from "../../../../../components/input-fields/SelectionListField";

const DtmfShortcutSection = ({ index, item, onContactUpdated }) => {
  const { updatedContacts } = useSelector((state) => state.companyDirectory);

  const getSelectedDtmfShortcutKeys = () => {
    const disabledOptions = [];
    updatedContacts.forEach((contact, i) => {
      if (i !== index)
        disabledOptions.push({
          option: contact.dtmfShortcutKey,
          disabledBy: `${contact.name}`.trim(),
        });
    });

    disabledOptions.push({
      option: "0",
      disabledBy: "Reserved for default contact",
    });

    return disabledOptions;
  };

  const selectedOptions = [
    { key: item.dtmfShortcutKey, type: "selected" },
    { key: item.isDefault ? "0" : null, type: "default" },
  ].filter((option) => option.key !== null);

  return (
    <SelectionListField
      title="Speed dial key"
      disabledOptions={getSelectedDtmfShortcutKeys()}
      options={["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "*", "#"]}
      selectedOptions={selectedOptions}
      setSelectedOptions={(selectedOptions) =>
        onContactUpdated(index, "dtmfShortcutKey", selectedOptions.length === 0 ? "" : selectedOptions[0].key)
      }
    />
  );
};

export default DtmfShortcutSection;
